import { FamilyRestroomOutlined } from "@mui/icons-material";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";

const PlaceholderInput = ({
  sample,
  sampleBodyFields,
  index,
  setsampleBodyFields,
  cardBody = false,
  options,
  disabled = false,
  label,
}) => {
  const selectOptions = options || ["name", "email", "language", "gender", "date_of_birth", "city", "state", "custom"];
  const optionLabels = { otp: "OTP code (generated at send)" };
  const selectLabel = label || `${cardBody ? "Card" : "Main"} Body Parameter ${index + 1}`;
  // OTP and custom values are typed in; other options use the contact field name
  const needsSample = sample.type === "custom" || sample.type === "otp";

  return (
    <Box
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 12,
      }}
    >
      <Box>
        <FormControl size="small" fullWidth>
          <InputLabel id={`main-body-param-label-${index}`}>
            {selectLabel}
          </InputLabel>
          <Select
            name={`${sample.type}_select`}
            labelId={`main-body-param-label-${index}`}
            label={selectLabel}
            value={sample.type}
            disabled={disabled}
            onChange={(event) => {
              if (cardBody) {
                setsampleBodyFields(event.target.value);
              } else {
                const newSamples = [...sampleBodyFields];
                const type = event.target.value;
                newSamples[index] = {
                  ...newSamples[index],
                  type,
                  value: type === "custom" || type === "otp" ? "" : type,
                };
                setsampleBodyFields(newSamples);
              }
            }}
          >
            {selectOptions.map((option) => (
              <MenuItem
                sx={{ textTransform: "capitalize" }}
                key={option}
                value={option}
              >
                {optionLabels[option] || option.replaceAll("_", " ")}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Box>
        {needsSample && (
          <TextField
            size="small"
            fullWidth
            label={"Sample Data"}
            name={sample.type}
            value={sample.value}
            onChange={(event) => {
              if (cardBody) {
                setsampleBodyFields(event.target.value);
              } else {
                const newSamples = [...sampleBodyFields];
                newSamples[index] = {
                  ...newSamples[index],
                  value: event.target.value,
                };
                setsampleBodyFields(newSamples);
              }
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default PlaceholderInput;
